import axios from "axios";

const axiosClient = axios.create({
});

// Wrappping http requests with authorization token in header
axiosClient.interceptors.request.use(
    function (config) {
        config.headers.Authorization =
            "Bearer " + localStorage.getItem("accessToken");
        return config;
    },
    function (error) {
        return Promise.reject(error);
    }
);

axiosClient.interceptors.response.use(
    function (response) {
        return response;
    },
    function (error) {
        if (error.response.data.message === "jwt expired") {
            let state = localStorage.getItem("persist:root");
            state = JSON.parse(state);
            delete state.user;
            delete state.cart;
            localStorage.setItem("persist:root", JSON.stringify(state));
            window.location.reload();
        }

        return Promise.reject(error);
    }
);

export default axiosClient;
